export const SERVER_URL = (import.meta.env.VITE_API_BASE_URL as string) ?? '';
